import BirlExerciseEntry from 'models/birl/exercise_entry'
import getModelCollection from 'braindamage/api/getModelCollection'
import { useQuery } from '@tanstack/react-query'

export default ({ query, path = "/api/birl/exercise_entries" } = {}) => {
  return useQuery({
    queryKey: ['birl_exercise_entries', path, query],
    queryFn: async () => {
      const data = await getModelCollection(path, BirlExerciseEntry, query)
      return data
    },
    onError: async (data) => {
      console.log("useBirlExerciseEntryCollectionQuery Error:", data)
    }
  })
}
